'use client'

import { BaseLink, Image } from '@/components/Core'
import { Button } from '@/components/Ui'
import { PageCardFragment } from '@/lib/fragments/page'
import { getParentSlug } from '@/lib/slugs'
import { Lib } from '@/types'
import { MEDIA } from '@config'
import clsx from 'clsx'
import { useTranslations } from 'next-intl'
import { HTMLAttributes, memo } from 'react'

export interface CardPageProps extends HTMLAttributes<HTMLDivElement> {
  data: Lib.FragmentOf<typeof PageCardFragment>
}

const CardPage = ({ data, className, ...props }: CardPageProps) => {
  const { image, pageTitle } = data

  const t = useTranslations()

  return (
    <BaseLink
      transitionType="slide"
      className="bg-white"
      href={`${getParentSlug(data.parent)}/${data.slug}`}
    >
      <div className={clsx('relative flex flex-col', className)} {...props}>
        <Image
          data={image}
          wrap={{
            className:
              'w-full overflow-hidden relative rounded-md mb-md object-cover '
          }}
          fitWrap
          sizes={`${MEDIA.sm} 20rem, 40rem`}
          ar="4x3"
        />
        <div className="p-sm flex flex-col items-start gap-4">
          {/* <p className="title-h3">{pageTitle}</p> */}
          <p className="text-large">{pageTitle}</p>
          <Button variant="text" as="button" isNext={false}>
            {t('read_more')}
          </Button>
        </div>
      </div>
    </BaseLink>
  )
}

export default memo(CardPage)
